import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Space, Card } from 'antd';
import PrintButton from '@/components/PrintButton/PrintButton';
import PrintOrthodonticExamForm from '@/routes/customers/Detail/OrthodonticExam/PrintOrthodonticExamForm';
import PrintGeneralExamForm from '@/routes/customers/Detail/GeneralExam/PrintGeneralExamForm';
import PrintTreatmentSessionForm from '@/routes/customers/Detail/TreatmentSessions/PrintTreatmentSessionForm';
import { getListProcedure } from '@/redux/actions/procedureActions';
import { getDiseasesActive } from '@/redux/actions/diseasesActions';
import PrintSurgeryCommitment from '@/components/print-templates/PrintSurgeryCommitment';
import PrintRepresentative from '@/components/print-templates/PrintRepresentative';
import PrintRefusa from '@/components/print-templates/PrintRefusa';
import PrintConsentBonding from '@/components/print-templates/PrintConsentBonding';
import PrintConsentToothReduction from '@/components/print-templates/PrintConsentToothReduction';
import PrintCommitmentBracketRemoval from '@/components/print-templates/PrintCommitmentBracketRemoval';
import PrintWarrantyConfirmation from '@/components/print-templates/PrintWarrantyConfirmation';
import PrintOrthoCompletion from '@/components/print-templates/PrintOrthoCompletion';
import PrintRetentionPhaseCommitment from '@/components/print-templates/PrintRetentionPhaseCommitment';

class Home extends Component {

    componentDidMount() {
        this.props.getDiseasesActive();
        this.props.getListProcedure({ status: 1, per_page: 1000 });
    }

    onClickModuleCard(redirectPath = null) {
        if (redirectPath) {
            this.props.history.push(redirectPath);
        }
    }

    render() {

        const { procedureList, diseases } = this.props;

        return (
            <div>
                <Row align="middle" justify="center" className='mt-3'>
                    <Col md={24} xs={24}>
                        <Card>

                            {/* 1. Khám lần đầu */}
                            <h5 className="mb-3">
                                1. Phiếu sử dụng cho khách hàng khám lần đầu
                            </h5>
                            <Space wrap size={[16, 24]}>
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In phiếu khám chỉnh nha"
                                >
                                    <PrintOrthodonticExamForm />
                                </PrintButton>

                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In phiếu khám tổng quát"
                                    disabled={!diseases?.length}
                                >
                                    <PrintGeneralExamForm diseases={diseases} />
                                </PrintButton>
                            </Space>

                            {/* 2. Điều trị – tái khám */}
                            <h5 className="mt-5 mb-3">
                                2. Phiếu sử dụng cho khách hàng tới điều trị, tái khám
                            </h5>
                            <Space wrap size={[16, 24]}>
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In phiếu điều trị"
                                    disabled={!procedureList?.length}
                                >
                                    <PrintTreatmentSessionForm data={procedureList} />
                                </PrintButton>
                            </Space>

                            {/* 3. Đồng ý điều trị chuyên biệt */}
                            <h5 className="mt-5 mb-3">
                                3. Giấy đồng ý điều trị chuyên biệt
                            </h5>
                            <Space wrap size={[16, 28]}>
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In giấy đồng ý mài răng thẩm mỹ"
                                    tooltipText="Giấy đồng ý mài răng trong điều trị răng thẩm mỹ"
                                >
                                    <PrintConsentToothReduction customer={{}} />
                                </PrintButton>

                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In giấy đồng ý gắn chặt răng"
                                    tooltipText="Giấy đồng ý gắn chặt răng"
                                >
                                    <PrintConsentBonding customer={{}} />
                                </PrintButton>

                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In cam kết tháo mắc cài"
                                    tooltipText="Trường hợp khách yêu cầu tháo mắc cài trước phác đồ"
                                >
                                    <PrintCommitmentBracketRemoval customer={{}} />
                                </PrintButton>
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In cam kết kết thúc điều trị chỉnh nha"
                                    tooltipText="Cam kết đồng ý kết thúc điều trị chỉnh nha mắc cài"
                                >
                                    <PrintOrthoCompletion customer={{}} />
                                </PrintButton>

                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In cam kết chuyển sang giai đoạn duy trì"
                                    tooltipText="Cam kết đồng ý chuyển sang giai đoạn duy trì sau điều trị chỉnh nha"
                                >
                                    <PrintRetentionPhaseCommitment customer={{}} />
                                </PrintButton>
                            </Space>

                            {/* 4. Cam kết & xác nhận pháp lý */}
                            <h5 className="mt-5 mb-3">
                                4. Giấy cam kết & xác nhận pháp lý
                            </h5>
                            <Space wrap size={[16, 28]}>

                                {/* Cam kết điều trị */}
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In giấy cam kết"
                                    tooltipText="Giấy cam kết chấp thuận phẫu thuật, thủ thuật và gây mê hồi sức"
                                >
                                    <PrintSurgeryCommitment
                                        customer={{}}
                                        data={{}}
                                    />
                                </PrintButton>

                                {/* Đại diện người bệnh */}
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In giấy đại diện"
                                    tooltipText="Giấy đề nghị làm người đại diện cho người bệnh"
                                >
                                    <PrintRepresentative
                                        customer={{}}
                                        data={{}}
                                    />
                                </PrintButton>

                                {/* Từ chối điều trị */}
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In giấy từ chối"
                                    tooltipText="Giấy cam kết từ chối sử dụng dịch vụ khám bệnh, chữa bệnh"
                                >
                                    <PrintRefusa
                                        customer={{}}
                                        data={{}}
                                    />
                                </PrintButton>

                                {/* Bảo hành */}
                                <PrintButton
                                    type="primary"
                                    size="large"
                                    printText="In xác nhận bảo hành & giới hạn trách nhiệm"
                                    tooltipText="Giấy xác nhận bảo hành & giới hạn trách nhiệm"
                                >
                                    <PrintWarrantyConfirmation customer={{}} />
                                </PrintButton>
                            </Space>
                        </Card>
                    </Col>
                </Row>
                {/* <Row align="middle" justify="center">
                    <Col md={24} xs={24}>
                        <Row gutter={16}>
                            {
                                parentModules.map((item, index) => (
                                    <Col lg={8} md={12} xs={24} key={index} className="w-100 mb-2">
                                        <ModuleCard
                                            className={`${item.className} align-items-center`}
                                            title={item.title}
                                            icon={item.icon}
                                            onClick={item.onClick}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Col>
                </Row> */}
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        procedureList: state.procedureReducer.procedureList,
        diseases: state.diseasesReducer.diseases_active_list,
        authUser: state.auth.authUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListProcedure: (filter) => dispatch(getListProcedure(filter)),
        getDiseasesActive: () => dispatch(getDiseasesActive())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);
